import * as Recoil from "recoil";
import * as React from "react";

import { controlCatalogIdState } from "atoms/atoms-global-control";
import { GlobalControlApi, AdminApi, useRoles } from "features/brm";
import { DEFAULT_CATALOG_NAME } from "constants/brm";

export const useControlCatalog = () => {
  const { isControlsCoordinator } = useRoles();
  const controlCatalogId = Recoil.useRecoilValue(controlCatalogIdState);

  const { data: controlCatalog } = GlobalControlApi.useControlCatalog({
    catalogId: controlCatalogId || "",
    options: { enabled: isControlsCoordinator },
  });
  const { data: selfData } = AdminApi.useSelf({ options: {} });

  const result = React.useMemo(() => {
    if (controlCatalog && selfData) {
      // looks like the only way to determine the default catalogs are by using the name... isDefault is always true.
      const isBuiltIn =
        controlCatalog.name === DEFAULT_CATALOG_NAME.name_4 || controlCatalog.name === DEFAULT_CATALOG_NAME.name_5;

      return {
        controlCatalogId,
        controlCatalog,
        isBuiltInCatalog: isBuiltIn,
        isReadOnlyCatalog: isBuiltIn || selfData.organization !== controlCatalog.organization,
      };
    }

    return {
      controlCatalogId,
      controlCatalog: undefined,
      isBuiltInCatalog: false,
      isReadOnlyCatalog: false,
    };
  }, [controlCatalog, controlCatalogId, selfData]);

  return result;
};
